var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSteelRank(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 13.6905H7",
    stroke: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 5.88096L7 13.6905V9.29762L16 1.4881V5.88096Z",
    stroke: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 13.6905C6.6 13.3 2.83333 10.5992 1 9.29764",
    stroke: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 9.78571V5.39286M12 5.39286C11.2 5.39286 7.66667 5.39286 6 5.39286L7 9.29762M12 5.39286C11.2 5.78333 8.66667 10.7619 7.5 13.2024M12 5.39286C13 5.55556 15.2 5.88095 16 5.88095M12 5.39286C12 4.6119 11.3333 2.13889 11 1",
    stroke: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1 13.6905V9.29764H7",
    stroke: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1 9.29762C1.4 8.90714 7.83333 3.60317 11 1C12.5 1 15.6 1 16 1",
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSteelRank);
export default __webpack_public_path__ + "static/media/steel_rank.728f423609baf2d7e40923b4754647f0.svg";
export { ForwardRef as ReactComponent };